var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotographicProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40204 9.40202 0 21 0C32.598 0 42 9.40204 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#FEF0ED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6452_86270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.25 17.25H25.575C25.4488 17.249 25.3249 17.2162 25.2148 17.1546C25.1047 17.0929 25.0119 17.0045 24.945 16.8975L24.195 15.6975C24.059 15.4827 23.8706 15.3061 23.6476 15.184C23.4246 15.062 23.1742 14.9987 22.92 15H19.08C18.8271 15 18.5782 15.0639 18.3566 15.1859C18.135 15.3078 17.9478 15.4838 17.8125 15.6975L17.0625 16.8975C16.9949 17.0056 16.901 17.0947 16.7894 17.1564C16.6779 17.218 16.5525 17.2503 16.425 17.25H15.75C15.1533 17.25 14.581 17.4871 14.159 17.909C13.7371 18.331 13.5 18.9033 13.5 19.5V24.75C13.5 25.3468 13.7371 25.9191 14.159 26.341C14.581 26.763 15.1533 27 15.75 27H26.25C26.8467 27 27.419 26.763 27.841 26.341C28.2629 25.9191 28.5 25.3468 28.5 24.75V19.5C28.5 18.9033 28.2629 18.331 27.841 17.909C27.419 17.4871 26.8467 17.25 26.25 17.25ZM21 24C20.555 24 20.12 23.8681 19.75 23.6208C19.38 23.3736 19.0916 23.0222 18.9213 22.6111C18.751 22.1999 18.7064 21.7475 18.7932 21.3111C18.88 20.8746 19.0943 20.4737 19.409 20.159C19.7237 19.8444 20.1246 19.6301 20.561 19.5433C20.9975 19.4564 21.4499 19.501 21.861 19.6713C22.2722 19.8416 22.6236 20.13 22.8708 20.5C23.118 20.87 23.25 21.305 23.25 21.75C23.25 22.3468 23.0129 22.9191 22.591 23.341C22.169 23.763 21.5967 24 21 24Z",
    fill: "#BC030E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6452_86270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotographicProducts);
export default __webpack_public_path__ + "static/media/photographic_products.0a8784a688e1599ab4c14a3943416459.svg";
export { ForwardRef as ReactComponent };